import lessRequire from '../../../config/less-require-resolver';
import React from 'react';
import ModalBox from '../../shared/modal';

import classname from 'classname';

lessRequire('modules/bm-accounts/components/popup-order.less');

const isEverad = process.env.CPA_ENV === 'everad';

const DownloadPopup = props => {
	const className = classname({
		'ReactModal__Content': true,
		'ReactModal__Content--after-open': true,
		'modal-overlay__content': true,
		'accounts-modal': true
	});
	let ModalBody, title;

	if (props.popupType === 'order') {
		ModalBody = ModalBodyOrder; title = props.intl('Покупка Бизнес Менеджер аккаунта');
	} else {
		ModalBody = ModalBodyOrderSuccess; title = props.intl('Спасибо!');
	}
	const onClose = () => {
		props.togglePopup();
		props.changePopupType('order');
	};

	return (
		<ModalBox
			body={ModalBody({...props, onClose})}
			isOpen={props.isOpen}
			onClose={onClose}
			title={title}
			className={className}
		/>
	);
};

const ModalBodyOrder = (props) => {
	const {id, name, description, image, price, currency} = props.popupAccountData || {};
	return (
		<div className="order__popup">
			<div
				className="account-description"
				style={ image ? {backgroundImage: `url('${image}')`} : {}}
			>
				<span>
					{`${name} ${description}`}
				</span>
			</div>
			<span className="popup__explanation">
				{`${props.intl('С вашего баланса будет списано')} ${currency}${price}` }
			</span>
			<button
				className="button yellow-btn font-proxima-nova-semibold order__button"
				onClick={() => props.orderAccount(id)}
			>
				{props.intl('Купить')}
			</button>
		</div>
	);
};

const ModalBodyOrderSuccess = (props) => {
	return (
		<div className="order__popup">
			<span className="popup__explanation">
				{props.intl('Для того, чтобы получить доступы к купленному аккаунту свяжитесь пожалуйста с менеджером')}
			</span>
			<a
				className="button yellow-btn font-proxima-nova-semibold order__button"
				onClick={props.onClose}
				target="_blank"
				href={isEverad ? 'https://t.me/Everad_Support' : 'https://telegram.me/r_kerimov'}
			>
				{props.intl('Связаться с менеджером')}
			</a>
		</div>
	);
};

export default DownloadPopup;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/bm-accounts/components/popup-order.js